import { AbilityBuilder, Ability } from '@casl/ability'
import AuthService from './authService';
/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
// function subjectName(item) {
//   if (!item || typeof item === 'string') {
//     return item
//   }
//   return item.__type
// }

// Define abilities
export const defineAbilitiesFor = () => {
    const { can, cannot, build } = new AbilityBuilder(Ability);

    // if (user.role === 'admin') {
    //     can('manage', 'all'); // Admin can do anything
    // } else {
    //     can('read', 'Post'); // Regular users can only read posts
    //     cannot('delete', 'Post'); // Example restriction
    // }
    var abilities = {};
    var roles = AuthService.getRoles();
    
    if (roles) {
        if(Array.isArray(roles)) {
            roles.map(i => {
                var roles = AuthService.getRoleClaims(i);
                if (roles) {
                    can(roles, i)
                } 
            })
        }
    else
    {
        var subject = AuthService.getRoles();
        var actions = AuthService.getRoleClaims(subject);
        
        if (actions) {
            can (actions, subject)
        } 
    }
    }
    abilities = build(); // Build and return the Ability instance
    return abilities;
}


